(function () {
  if (window.QQProductDealsGrid && typeof window.QQProductDealsGrid.init === 'function') {
    window.QQProductDealsGrid.init();
    return;
  }

  var activeModal = null;
  var lastTrigger = null;
  var previousBodyOverflow = '';

  function init(scope) {
    var target = scope || document;
    var roots = [];
    if (target.matches && target.matches('.qq-5-product-deals-grid')) {
      roots.push(target);
    }
    target.querySelectorAll && target.querySelectorAll('.qq-5-product-deals-grid').forEach(function (root) {
      roots.push(root);
    });
    roots.forEach(initRoot);
  }

  function initRoot(root) {
    if (root.hasAttribute('data-qq-product-grid-initialized')) return;
    root.setAttribute('data-qq-product-grid-initialized', 'true');

    root.querySelectorAll('[data-qq-open-modal]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var modal = document.getElementById(trigger.getAttribute('data-qq-open-modal'));
        if (modal) openModal(modal, trigger);
      });
    });

    root.querySelectorAll('[data-qq-product-modal]').forEach(initModal);
  }

  function initModal(modal) {
    if (modal.hasAttribute('data-qq-modal-initialized')) return;
    modal.setAttribute('data-qq-modal-initialized', 'true');

    var form = modal.querySelector('[data-qq-product-form]');
    var variants = readVariants(modal);

    modal.querySelectorAll('[data-qq-close-modal]').forEach(function (closeControl) {
      closeControl.addEventListener('click', function () {
        closeModal(modal);
      });
    });

    modal.querySelectorAll('[data-qq-option-value]').forEach(function (button) {
      button.addEventListener('click', function () {
        selectOption(button);
        updateVariant(modal, variants);
      });
    });

    var quantityInput = modal.querySelector('[data-qq-quantity]');
    var minus = modal.querySelector('[data-qq-qty-minus]');
    var plus = modal.querySelector('[data-qq-qty-plus]');
    if (minus && quantityInput) {
      minus.addEventListener('click', function () {
        var value = Math.max(1, parseInt(quantityInput.value || '1', 10) - 1);
        quantityInput.value = String(value);
      });
    }
    if (plus && quantityInput) {
      plus.addEventListener('click', function () {
        var value = Math.max(1, parseInt(quantityInput.value || '1', 10) + 1);
        quantityInput.value = String(value);
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        addToCart(modal, form, false);
      });
    }

    var checkout = modal.querySelector('[data-qq-checkout]');
    if (checkout && form) {
      checkout.addEventListener('click', function () {
        addToCart(modal, form, true);
      });
    }

    updateVariant(modal, variants);
  }

  function readVariants(modal) {
    var json = modal.querySelector('[data-qq-variant-json]');
    if (!json) return [];
    try {
      return JSON.parse(json.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function openModal(modal, trigger) {
    if (activeModal && activeModal !== modal) closeModal(activeModal);
    activeModal = modal;
    lastTrigger = trigger;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    previousBodyOverflow = document.body.style.overflow || '';
    document.body.style.overflow = 'hidden';

    var dialog = modal.querySelector('[role="dialog"]');
    var initialFocus = modal.querySelector('[data-qq-initial-focus]') || getFocusable(modal)[0] || dialog;
    if (initialFocus) initialFocus.focus();

    document.addEventListener('keydown', handleDocumentKeydown);
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (activeModal === modal) activeModal = null;
    document.body.style.overflow = previousBodyOverflow;
    document.removeEventListener('keydown', handleDocumentKeydown);
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
    lastTrigger = null;
  }

  function handleDocumentKeydown(event) {
    if (!activeModal) return;
    if (event.key === 'Escape') {
      closeModal(activeModal);
      return;
    }
    if (event.key !== 'Tab') return;

    var focusable = getFocusable(activeModal);
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (!activeModal.contains(document.activeElement)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function getFocusable(container) {
    return Array.prototype.slice.call(container.querySelectorAll('a[href], button:not([disabled]):not([tabindex="-1"]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (element) {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement;
      });
  }

  function selectOption(button) {
    var group = button.closest('[data-qq-option-group]');
    if (!group) return;
    group.querySelectorAll('[data-qq-option-value]').forEach(function (item) {
      var isSelected = item === button;
      item.classList.toggle('is-selected', isSelected);
      item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
    var selected = group.querySelector('[data-qq-selected-option]');
    if (selected) selected.textContent = button.getAttribute('data-qq-option-value') || button.textContent.trim();
  }

  function getSelectedOptions(modal) {
    var selected = [];
    modal.querySelectorAll('[data-qq-option-group]').forEach(function (group) {
      var position = parseInt(group.getAttribute('data-option-position') || '1', 10);
      var active = group.querySelector('[data-qq-option-value].is-selected');
      if (active) selected[position - 1] = active.getAttribute('data-qq-option-value') || active.textContent.trim();
    });
    return selected;
  }

  function updateVariant(modal, variants) {
    if (!variants.length) return;
    var selected = getSelectedOptions(modal);
    var variant = variants.find(function (item) {
      if (!selected.length) return item.id == getVariantInput(modal).value;
      return selected.every(function (value, index) {
        return !value || item['option' + (index + 1)] === value;
      });
    });

    var variantInput = getVariantInput(modal);
    var add = modal.querySelector('[data-qq-add-to-cart]');
    var checkout = modal.querySelector('[data-qq-checkout]');
    var isAvailable = Boolean(variant && variant.available);

    if (variant && variantInput) {
      variantInput.value = variant.id;
    }
    [add, checkout].forEach(function (button) {
      if (!button) return;
      button.disabled = !isAvailable;
    });
    setMessage(modal, isAvailable ? '' : 'This option is currently unavailable.', !isAvailable);
  }

  function getVariantInput(modal) {
    return modal.querySelector('[data-qq-variant-id]');
  }

  function addToCart(modal, form, goToCheckout) {
    var variantInput = getVariantInput(modal);
    var quantityInput = modal.querySelector('[data-qq-quantity]');
    var id = variantInput && variantInput.value;
    var quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value || '1', 10)) : 1;
    if (!id) {
      setMessage(modal, 'Please choose an available option.', true);
      return;
    }

    var buttons = form.querySelectorAll('[data-qq-add-to-cart], [data-qq-checkout]');
    buttons.forEach(function (button) {
      button.disabled = true;
    });
    setMessage(modal, goToCheckout ? 'Preparing checkout...' : 'Adding to cart...', false);

    fetch(getCartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: Number(id), quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      })
      .then(function () {
        if (goToCheckout) {
          window.location.href = getRouteUrl('checkout');
          return;
        }
        closeModal(modal);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      })
      .catch(function () {
        setMessage(modal, 'Unable to add this product. Please try again.', true);
      })
      .finally(function () {
        buttons.forEach(function (button) {
          button.disabled = false;
        });
        updateVariant(modal, readVariants(modal));
      });
  }

  function setMessage(modal, text, isError) {
    var message = modal.querySelector('[data-qq-modal-message]');
    if (!message) return;
    message.textContent = text || '';
    message.classList.toggle('is-error', Boolean(isError));
  }

  function getRouteUrl(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function getCartAddUrl() {
    return getRouteUrl('cart/add.js');
  }

  window.QQProductDealsGrid = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var modal = event.target && event.target.querySelector && event.target.querySelector('[data-qq-product-modal].is-open');
    if (modal) closeModal(modal);
  });
})();
